import httpClient from "@/plugins/axios";
import moment from "moment";



export const getNewsList = async (page, pageSize, query) => {
    const params = {
        page: page,
        page_size: pageSize,
    }
    if (query) {
        params['search'] = query;
    }
    const response = await httpClient.get(`/admin/v1/news/`,
        {
            params: params
        }
    );
    return response;
}

export const getNews = async (newsId) => {
    const response = await httpClient.get(`/admin/v1/news/${newsId}/`);
    return response;
}

export const saveNews = async (news, newImageBlob, newImageName, removeImage) => {
    const formData = getFormData(news, newImageBlob, newImageName, removeImage);

    if (news.id) {
        return await updateNews(news.id, formData);
    }
    else {
        return await insertNews(formData);
    }
}

const insertNews = async (formData) => {
    const response = await httpClient.post('/admin/v1/news/?html=true', formData)
    return response;
}

const updateNews = async (id, formData) => {
    const response = await httpClient.put(`/admin/v1/news/${id}/?html=true`, formData)
    return response;
}

export const deleteNews = async (id) => {
    const response = httpClient.delete(`/admin/v1/news/${id}/`);
    return response;
}

export const saveNewsAttachment = async (file) => {
    const formData = new FormData()
    formData.append('file', file)

    var response = await httpClient.post(
        `/admin/v1/news/attachments/`,
        formData
    )

    return response;
}

export const downloadNewsAttachment = async (newsId, attachmentId) => {
    const response = await httpClient.get(
        `/v1/news/${newsId}/attachments/${attachmentId}/?admin_view=1`,
        {
            responseType: 'blob',
        }
    )

    return response;
}

export const removeNewsAttachment = async (newsId, attachmentId) => {
    const response = await httpClient.delete(
        `/v1/news/${newsId}/attachments/${attachmentId}/`
    );

    return response;
}


const getFormData = (news, newImageBlob, newImageName, removeImage) => {
    const formData = new FormData()

    if (news.id) {
        formData.append('id', news.id)
    }
    formData.append('group', parseInt(news.group))

    const m = moment(news.release_date, 'DD.MM.YYYY HH:mm')
    formData.append('release_date', m.format('DD.MM.YYYY HH:mm'))

    formData.append('expire_date', '')
    formData.append('poll', news.poll ?? '')
    formData.append('published', news.published)
    formData.append('infotv', news.infotv)
    formData.append('translations', JSON.stringify(news.translations))

    news.attachments.forEach(a => {
        formData.append('attachments', a);
    });

    if (newImageBlob) {
        formData.append('image', newImageBlob, newImageName);
    } else if (removeImage) {
        formData.append('remove_image', true)
    }

    if (news.videoUrl) {
        formData.append('video_url', news.videoUrl)
    }

    // Tags
    if (news.tags && news.tags.length > 0) {
        news.tags.forEach(tag => {
            if (tag.id) {
                formData.append('tags', tag.id);
            }
        });
    }

    return formData;
}
